export default "__VITE_ASSET__70539637__"